import React, {memo} from "react"
import {shapeComponent, ShapeComponent} from "set-state-compare/build/shape-component"
import Table from "tabloom/build/table"

export default memo(shapeComponent(class CardTableTable extends ShapeComponent {
  render() {
    return (
      <Table {...this.props} />
    )
  }
}))
